
export default {
  name: 'VacanciesAdvantageCard',

  props: {
    advantage: {
      type: Object,
      default: () => ({}),
    },
    advantageIndex: {
      type: Number,
      default: -1,
    },
  },
  computed: {
    itsEven: function () {
      return ( (this.advantageIndex + 1) % 2 ) === 0;
    },
  },
};
